export default () => {
    let usr = navigator.userAgent
    let device = usr.match( /Android/i ) || usr.match( /BlackBerry/i ) || usr.match( /iPhone/i ) || usr.match( /iPad/i ) || usr.match( /iPod/i ) || usr.match( /iPhone|iPad|iPod/i ) || usr.match( /IEMobile/i )
    let is_mobile = device !== null
    return is_mobile
}